import { EDeviceType, ESiteType, TDeviceType, TSiteType } from '../../store';

export function serializeDeviceType(deviceType: TDeviceType): TSiteType {
  switch (deviceType) {
    case EDeviceType.desktop:
      return ESiteType.desktop;
    case EDeviceType.tablet:
      return ESiteType.tablet;
    case EDeviceType.phone:
      return ESiteType.mobile;
    default:
      return null;
  }
}
